import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Backdrop, Button, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import { selectAudioInteractionNeeded, retryPendingNarration } from '../hostStateSlice';

const StyledBackdrop = styled(Backdrop)({
  zIndex: 1300,
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  backdropFilter: 'blur(4px)',
});

const EnableButton = styled(Button)(({ theme }) => ({
  background: 'linear-gradient(120deg, #ffe066 0%, #2ec4b6 50%, #ffe066 100%)',
  backgroundSize: '200% 200%',
  backgroundPosition: '0% 40%',
  color: '#222',
  padding: theme.spacing(2, 5),
  borderRadius: 16,
  fontWeight: 700,
  fontSize: '1.3rem',
  textTransform: 'none',
  boxShadow: '0 4px 20px rgba(46, 196, 182, 0.4)',
  transition: 'background-position 0.5s ease, transform 0.2s ease',
  '&:hover': {
    backgroundPosition: '100% 60%',
    transform: 'scale(1.05)',
  },
}));

const AudioInteractionOverlay = () => {
  const dispatch = useDispatch();
  const needed = useSelector(selectAudioInteractionNeeded);

  if (!needed) return null;

  const handleClick = () => {
    dispatch(retryPendingNarration());
  };

  return (
    <StyledBackdrop open={true} onClick={handleClick}>
      <Box sx={{ textAlign: 'center' }}>
        <VolumeUpIcon sx={{ fontSize: 64, color: '#fff', mb: 2 }} />
        <Typography variant="h5" sx={{ color: '#fff', mb: 3, fontFamily: "'Gyparody', sans-serif" }}>
          Audio Paused
        </Typography>
        <EnableButton variant="contained" onClick={handleClick}>
          Tap to Enable Audio
        </EnableButton>
      </Box>
    </StyledBackdrop>
  );
};

export default AudioInteractionOverlay;
